<template>
    <div
        class="searchSection searchSection--contacts"
        :class="{
            searchSection__clearPaddingBottom: pagination.total <= limit || !items.length
        }"
    >
        <div
            v-show="items.length"
            class="searchSection__items"
            :class="{
                'create-contact-modal': isCreateContactModal
            }"
        >
            <template v-for="(contact, i) in items">
                <template v-if="newSearch">
                    <search-item
                        :item="contact"
                        :key="contact.id"
                        :index="i"
                        :starting="starting"
                        :shouldShowStart="shouldShowStart"
                        @mouseOver="mouseOver"
                        @mouseOut="mouseOut"
                        @enter="enter"
                        @start="start"
                    />
                </template>
                <template v-else>
                    <search-item-old
                        :item="contact"
                        :key="contact.id"
                        :index="i"
                        :starting="starting"
                        @mouseOver="mouseOver"
                        @mouseOut="mouseOut"
                        @enter="enter"
                        @start="start"
                    />
                </template>
            </template>
        </div>

        <div
            v-show="items.length"
            class="searchContacts__pagination"
        >
            <datatable-pagination
                :pages="pagination"
                :lengthSelectorDisabled="true"
                :type="'simple'"
                :lastPage="true"
                :firstPage="true"
                :maxPages="3"
                @updatePage="updatePage"
            />
        </div>
    </div>
</template>

<script>
import InitialsMixin from '../../../../mixins/initials.js';
import UserMixin from '../../../../mixins/user';
import DatatablePagination from '../../../../components/Datatable/Pagination';
import SearchItem from './SearchItem';
import SearchItemOld from './SearchItemOld';

export default {
    components: {
        SearchItem,
        SearchItemOld,
        DatatablePagination,
    },

    mixins: [
        InitialsMixin,
        UserMixin,
    ],

    props: [
        'items',
        'counter',
        'starting',
        'pagination',
        'name',
        'limit',
        'newSearch',
        'shouldShowStart',
        'query'
    ],

    computed: {
        isCreateContactModal() {
            return this.$route.path === '/conversations/create' || this.$route.path === '/contacts/create'
        }
    },

    methods: {
        start(contact) {
            this.$emit('start', contact);
        },

        enter(contact, type, label) {
            this.$emit('enter', contact, type, label);
        },

        mouseOver(i) {
            this.$emit('mouseOver', i);
        },

        mouseOut() {
            this.$emit('mouseOut');
        },

        updatePage(page) {
            this.$store.dispatch(`${this.name}UpdatePage`, { page, isSearchTop: true, query: this.query || null });
        },
    },
};
</script>
